import { FC } from 'react'
import { RiskScoreRoutes } from './RiskScore/Routes'

export interface ITabList {
  tabLabel: string
  slug: string
  component: FC
}

export const tabList: ITabList[] = [
  {
    tabLabel: 'Risk Score',
    slug: 'risk-score',
    component: RiskScoreRoutes,
  },
]
